const language = window.localStorage.getItem('language');

export const months = [
    {value: 1, label: language === 'ar' ? 'يناير' : 'January'},
    {value: 2, label: language === 'ar' ? 'فبراير' : 'February'},
    {value: 3, label: language === 'ar' ? 'مارس' : 'March'},
    {value: 4, label: language === 'ar' ? 'أبريل' : 'April'},
    {value: 5, label: language === 'ar' ? 'مايو' : 'May'},
    {value: 6, label: language === 'ar' ? 'يونيو' : 'June'},
    {value: 7, label: language === 'ar' ? 'يوليو' : 'July'},
    {value: 8, label: language === 'ar' ? 'أغسطس' : 'August'},
    {value: 9, label: language === 'ar' ? 'سبتمبر' : 'September'},
    {value: 10, label: language === 'ar' ? 'أكتوبر' : 'October'},
    {value: 11, label: language === 'ar' ? 'نوفمبر' : 'November'},
    {value: 12, label: language === 'ar' ? 'ديسمبر' : 'December'}
]
export const month_mobiles = [
    {value: 1, label: language === 'ar' ? 'يناير' : 'Jan'},
    {value: 2, label: language === 'ar' ? 'فبراير' : 'Feb'},
    {value: 3, label: language === 'ar' ?  'مارس' : 'Mar'},
    {value: 4, label: language === 'ar' ? 'أبريل' : 'Apr'},
    {value: 5, label: language === 'ar' ? 'مايو' : 'May'},
    {value: 6, label: language === 'ar' ? 'يونيو' : 'Jun'},
    {value: 7, label: language === 'ar' ? 'يوليو' : 'Jul'},
    {value: 8, label: language === 'ar' ? 'أغسطس' : 'Aug'},
    {value: 9, label: language === 'ar' ? 'سبتمبر' : 'Sep'},
    {value: 10, label: language === 'ar' ? 'أكتوبر' : 'Oct'},
    {value: 11, label: language === 'ar' ? 'نوفمبر' : 'Nov'},
    {value: 12, label: language === 'ar' ? 'ديسمبر' : 'Dec'}
]